import { portalRoutes } from "@nju/routes";
import { Panel, Separator } from "@nju/ui";
import { RichRowLink, RichRowTitle } from "./RichRow";
import { Title } from "./Title";

export function ConsentsInfo() {
  return (
    <Panel>
      <Title iconName="check-double" title="zgody" />
      <Separator size="s" />
      <div className="flex justify-between only-mobile:items-center from-desktop:items-end">
        <div>
          <RichRowTitle title="wszelkie zgody produktowe" />
          <RichRowTitle title="i marketingowe" />
        </div>
        <RichRowLink
          id="change-consents"
          link={portalRoutes.mojeKonto.mojProfil.zmienZgody.get()}
        />
      </div>
    </Panel>
  );
}
